import translations from '@/../../i18n/translations'
import { v1 as uuidv1 } from 'uuid'

export default {
  translations: translations,
  availableLanguages: {
    ar: 'عربى',
    en_US: 'English (US)',
    en_GB: 'English (UK)',
    es: 'Español',
    da: 'Dansk',
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
    ja: '日本語',
    ko: '한국어',
    nl: 'Nederlands',
    pl: 'Polski',
    pt: 'Português',
    ro: 'Română',
    ru: 'Russian',
    sv: 'Svenska',
    th: 'Thai',
    tr: 'Türk',
    vi: 'Tiếng Việt',
    zh: '普通话'
  },
  languageVmMixin: {
    methods: {
      uuidKey: function () {
        return uuidv1()
      }
    }
  },
  silent: true
}
